<template>
  <div ref="domRef" :class="['base-card-info', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      公司介绍
    </div>
    <change-record-container>
      <template #before>
        <div class="left-list gap-y-[14px]">
          <div class="item">
            <div class="label h-[30px] leading-[30px]">
              《企业入驻表》
            </div>
            <div v-if="isNull(baseInfo?.pre?.companySettled?.settledList) || baseInfo?.pre?.companySettled?.settledList.length === 0" class="value">
              --
            </div>
            <div v-else class="value !block">
              <div
                v-for="(v, idx) in baseInfo?.pre?.companySettled?.settledList"
                :key="idx"
                class="flex align-items-center !gap-[6px]"
              >
                <div class="flex justify-between items-center px-2 cursor-pointer text-[#344767] text-sm h-[30px]">
                  <div class="flex h-full items-center">
                    <svg-icon class="file-icon mr-2 !w-4 !h-4" icon="ph:file-text" />
                    <div class="w-[200px] truncate">
                      {{ v?.fileName }}
                    </div>
                  </div>
                  <div class="flex h-full items-center">
                    <svg-icon class="file-icon main-primary-text mx-2 !w-4 !h-4" icon="tabler:arrow-bar-to-down" @click="downLoadFile(v)" />
                    <svg-icon
                      v-if="imageTypeStrs.includes(getFileExt(v.fileUrl)) || officeFileTypes.includes(getFileExt(v.fileUrl))"
                      class="file-icon main-primary-text !w-4 !h-4"
                      icon="lucide:search"
                      @click="previewFile(v)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #after>
        <div class="left-list gap-y-[14px]">
          <div class="item">
            <div class="label h-[30px] leading-[30px]">
              《企业入驻表》
            </div>
            <div v-if="isNull(baseInfo?.post?.companySettled?.settledList) || baseInfo?.post?.companySettled?.settledList.length === 0" class="value">
              --
            </div>
            <div v-else class="value !block">
              <div
                v-for="(v, idx) in baseInfo?.post?.companySettled?.settledList"
                :key="idx"
                class="flex align-items-center !gap-[6px]"
              >
                <div class="flex justify-between items-center px-2 cursor-pointer text-[#344767] text-sm h-[30px]">
                  <div class="flex h-full items-center">
                    <svg-icon class="file-icon mr-2" icon="ph:file-text" />
                    <div class="w-[200px] truncate">
                      {{ v?.fileName }}
                    </div>
                  </div>
                  <div class="flex h-full items-center">
                    <svg-icon class="file-icon main-primary-text mx-2  !w-4 !h-4" icon="tabler:arrow-bar-to-down" @click="downLoadFile(v)" />
                    <svg-icon
                      v-if="imageTypeStrs.includes(getFileExt(v.fileUrl)) || officeFileTypes.includes(getFileExt(v.fileUrl))"
                      class="file-icon main-primary-text  !w-4 !h-4"
                      icon="lucide:search"
                      @click="previewFile(v)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </change-record-container>
  </div>
</template>

<script setup lang="ts">
import { getFileExt, imageTypeStrs, isNull, officeFileTypes } from '@core/tools';
import ChangeRecordContainer from './change-record-container.vue';
import { openImagePreviewByUrl, useElementImgPreview, SvgIcon } from '@vue3/components';
import { ICompanyChangeRecord } from '@core/main/types';
import { inject, Ref, ref } from 'vue';
import { previewOfficeFile } from '@core/main';
import { downloadLinkFile } from '@core/api';

defineOptions({ name: 'CompanyIntroduction' }); // 账户中心 - 公司介绍

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

/**
 * @function 预览文件
*/
function previewFile(file: any) {
  if (officeFileTypes.includes(getFileExt(file.fileUrl))) {
    previewOfficeFile(file.fileUrl);
  }
  if (imageTypeStrs.includes(getFileExt(file.fileUrl))) {
    openImagePreviewByUrl(file.fileUrl);
  }
}

/**
 * @function 下载文件
*/
function downLoadFile(file: any) {
  downloadLinkFile(file.fileUrl);
}

const baseInfo = inject<Ref<ICompanyChangeRecord>>('baseInfo');
</script>

<style lang="scss" scoped>
:deep(.file-icon) {
  @apply w-[16px] h-[16px];
}
</style>
